/* eslint-disable @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires */

export const GradientOverlay = require('./gradient-overlay.png');
